var map = {
	"./360-factory-visibility.svg": 1188,
	"./automated-material-flow.svg": 1189,
	"./course-symb.svg": 1190,
	"./data-driven-maintenance.svg": 1191,
	"./digital-organization.svg": 1192,
	"./digital-ready-infrastructure.svg": 1193,
	"./education-anaytics.svg": 602,
	"./fof-leadership.svg": 603,
	"./imd-partnership-logo.svg": 393,
	"./inner-360-factory-visibility.svg": 604,
	"./inner-automated-material-flow.svg": 605,
	"./inner-course-symb.svg": 606,
	"./inner-data-driven-maintenance.svg": 607,
	"./inner-digital-organization.svg": 608,
	"./inner-digital-ready-infrastructure.svg": 609,
	"./inner-fof-leadership.svg": 610,
	"./inner-intelligent-quality.svg": 611,
	"./inner-sustainability.svg": 612,
	"./inner-tech-augmented-workforce.svg": 613,
	"./inner-zero-touches-production.svg": 614,
	"./intelligent-quality.svg": 1194,
	"./offer-img.svg": 394,
	"./skills-assessment.svg": 1195,
	"./sustainability.svg": 1196,
	"./tech-augmented-workforce.svg": 1197,
	"./zero-touches-production.svg": 1198
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 123;